<template>
    <div class="outline-popup" @click.self="closePopup">
        <div class="right-left">
            <div class="right-left-title">
                <div class="right-left-title-empty"> </div>
                <div class="right-left-title-text" v-if="PopupType == 'AllDevice'">{{ $t('smartCity.HomeBakDeviceList.719300-0') }}</div>
                <div class="right-left-title-text" v-if="PopupType == 'AlarmDevice'">{{ $t('smartCity.HomeBakDeviceList.719300-1') }}</div>
                <div class="right-left-title-text" v-if="PopupType == 'online'">{{ $t('smartCity.HomeBakDeviceList.719300-2') }}</div>
                <div class="right-left-title-text" v-if="PopupType == 'AlarmHandle'">{{ $t('smartCity.HomeBakDeviceList.719300-3') }}</div>
                <div class="right-left-title-text" v-if="PopupType == 'ZuiJinAlarmDevice'">{{ $t('smartCity.HomeBakDeviceList.719300-4') }}</div>
                <img class="iconimg" @click="closePopup" src="../../assets/homeback/closePopup.png" alt="">
            </div>
            <div class="right-left-input">
                <span v-if="PopupType == 'AllDevice'" class="dpf_aic">
                    <div>{{ $t('smartCity.HomeBakDeviceList.719300-5') }}</div>
                    <input :placeholder="$t('smartCity.HomeBakDeviceList.719300-6')" v-model="InputParams">
                </span>
                <span class="dpf_aic"
                    v-if="PopupType == 'AlarmDevice' || PopupType == 'AlarmHandle' || PopupType == 'online' || PopupType == 'ZuiJinAlarmDevice'">
                    <div>{{ $t('smartCity.HomeBakDeviceList.719300-7') }}</div>
                    <input :placeholder="$t('smartCity.HomeBakDeviceList.719300-8')" v-model="InputParams">
                </span>
                <span class="dpf_aic">
                    <div>{{ $t('smartCity.HomeBakDeviceList.719300-9') }}</div>
                    <Select class="inputSelect" v-model="InputTypeParams">
                        <Option v-for="(item,index ) in DeviceTypeList" :key="index" :value="item.value">{{ item.name }}</Option>
                    </Select>
                </span>
                <div class="searchButton" @click="search">
                    <img style="width:20px;height: auto;margin-right: 5px;" src="../../assets/homeback/search.png">
                    <span>{{ $t('smartCity.HomeBakDeviceList.719300-10') }}</span>
                </div>
            </div>
            <div class="right-left-table" v-if="PopupType == 'AllDevice'">
                <div class="table">
                    <div class="right-left-table-th right-left-table-th4">{{ $t('smartCity.HomeBakDeviceList.719300-11') }}</div>
                    <div class="right-left-table-th right-left-table-th3">{{ $t('smartCity.HomeBakDeviceList.719300-12') }}</div>
                    <div class="right-left-table-th right-left-table-th4">{{ $t('smartCity.HomeBakDeviceList.719300-5') }}</div>
                    <div class="right-left-table-th right-left-table-th5">{{ $t('smartCity.HomeBakDeviceList.719300-13') }}</div>
                    <div class="right-left-table-th right-left-table-th3">{{ $t('smartCity.HomeBakDeviceList.719300-14') }}</div>
                    <div class="right-left-table-th right-left-table-th3">{{ $t('smartCity.HomeBakDeviceList.719300-15') }}</div>
                    <div class="right-left-table-th right-left-table-th5">{{ $t('smartCity.HomeBakDeviceList.719300-16') }}</div>
                </div>
                <div class="right-left-table-content">
                    <div class="right-left-table-tr" :class="index % 2 == 0 ? 'bg' : 'bg1'"
                        v-for="(item, index) in DeviceList" :key="index">
                        <div class="tr tr4">{{ item.Address }}</div>
                        <div class="tr tr3">{{ item.DeviceCode }}</div>
                        <div class="tr tr4">{{ item.UserDeviceName }}</div>
                        <div class="tr tr5">{{ item.UpdateTime }}</div>
                        <div class="tr tr3" :class="item.IsOnline == 1 ? 'greenText' : 'redText'">{{ item.IsOnline == 1 ?
                            $t('smartCity.HomeBakDeviceList.719300-17') :
                            $t('smartCity.HomeBakDeviceList.719300-18') }}</div>
                        <div class="tr tr3">
                            <img class="Statusimg" v-if="item.SwitchStatus == 2" src="../../assets/homeback/close.png"
                                alt="">
                            <img class="Statusimg" v-else-if="item.SwitchStatus == 1" src="../../assets/homeback/open.png"
                                alt="">
                            <span v-else>--</span>
                        </div>
                        <div class="tr tr5 greenText">
                            <div class="map-right-group-btn" style="display: flex; align-items: center;">
                                <Poptip v-if="DeviceBtns.indexOf('slience') >= 0"
                                    style="align-items: center; margin-left: 5px;" confirm :title="$t('smartCity.HomeBakDeviceList.719300-19')"
                                    placement="top-start" offset='0' @on-ok="Device_YanGan_Silence(item)"
                                    @on-cancel="cancel">
                                    <div>
                                        <p>{{ $t('smartCity.HomeBakDeviceList.719300-20') }}</p>
                                    </div>
                                </Poptip>

                                <div v-if="DeviceBtns.indexOf('read') >= 0 && item.DeviceId == '6ee95d23-a802-4bd8-b823-19c0944ac5ab'"
                                    style="cursor: pointer;" :class="{ 'allowed': !callState }"
                                    @click="InitDeviceRead(item.DeviceCode, item.Id)">
                                    <p>{{ $t('smartCity.HomeBakDeviceList.719300-21') }}</p>
                                </div>

                                <Poptip
                                    v-if="DeviceBtns.indexOf('open') >= 0 && item.SwitchStatus != 2 && item.DeviceId == '6ee95d23-a802-4bd8-b823-19c0944ac5ab'"
                                    confirm :title="$t('smartCity.HomeBakDeviceList.719300-22')" :disabled="!saveState" placement="top-start" offset='0'
                                    @on-ok="VerifyPassword(item, 1)" @on-cancel="cancel">
                                    <div style="cursor: pointer;">
                                        <p>{{ $t('smartCity.HomeBakDeviceList.719300-23') }}</p>
                                    </div>
                                </Poptip>

                                <Poptip
                                    v-if="DeviceBtns.indexOf('close') >= 0 && item.SwitchStatus != 1 && item.DeviceId == '6ee95d23-a802-4bd8-b823-19c0944ac5ab'"
                                    confirm :title="$t('smartCity.HomeBakDeviceList.719300-24')" :disabled="!saveState" placement="top-start" offset='0'
                                    @on-ok="VerifyPassword(item, 1)" @on-cancel="cancel">
                                    <div style="cursor: pointer;">
                                        <p>{{ $t('smartCity.HomeBakDeviceList.719300-25') }}</p>
                                    </div>
                                </Poptip>

                                <Poptip v-if="DeviceBtns.indexOf('closeFa') >= 0" confirm :title="$t('smartCity.HomeBakDeviceList.719300-26')"
                                    :disabled="!saveState" placement="top-start" offset='0' @on-ok="VerifyPassword(item, 2)"
                                    @on-cancel="cancel">
                                    <div style="cursor: pointer;">
                                        <p>{{ $t('smartCity.HomeBakDeviceList.719300-27') }}</p>
                                    </div>
                                </Poptip>

                                <div style="cursor: pointer;"
                                    v-if="item.DeviceId == '88f5c429-49b6-4a9f-a908-b2ee9c8cb857' && item.DeviceItemId != '881a191a-e3da-4bea-867a-69988dbf1fef' && item.DeviceItemId != '147df81e-3f30-49b7-8894-f0b5794d917f' && item.DeviceItemId != 'c5307581-ff30-4115-87c0-52ac83bbd1cc'"
                                    @click="GetQtcgqTtItemList(item.DeviceCode)">
                                    <p>{{ $t('smartCity.HomeBakDeviceList.719300-28') }}</p>
                                </div>

                                <div style="cursor: pointer;" v-if="DeviceBtns.indexOf('edit') >= 0"
                                    @click="userListHide(true, 103)">
                                    <p>{{ $t('smartCity.HomeBakDeviceList.719300-29') }}</p>
                                </div>
                                <Poptip v-if="DeviceBtns.indexOf('del') >= 0" confirm :title="$t('smartCity.HomeBakDeviceList.719300-30')" placement="top-end"
                                    offset='-20' @on-ok="ok" @on-cancel="cancel">
                                    <div style="cursor: pointer;" class="map-right-group-btn-item set">
                                        <p>{{ $t('smartCity.HomeBakDeviceList.719300-31') }}</p>
                                    </div>
                                </Poptip>
                                <span style="cursor: pointer;" @click="ShowPopupDevice(item)">{{ $t('smartCity.HomeBakDeviceList.719300-32') }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="none" v-if="DeviceList.length == 0">{{ $t('smartCity.HomeBakDeviceList.719300-33') }}</div>
                </div>
            </div>
            <div class="right-left-table" v-if="PopupType == 'online'">
                <div class="table">
                    <div class="right-left-table-th right-left-table-th3">{{ $t('smartCity.HomeBakDeviceList.719300-5') }}</div>
                    <div class="right-left-table-th right-left-table-th3">{{ $t('smartCity.HomeBakDeviceList.719300-12') }}</div>
                    <div class="right-left-table-th right-left-table-th3">{{ $t('smartCity.HomeBakDeviceList.719300-34') }}</div>
                    <div class="right-left-table-th right-left-table-th3">{{ $t('smartCity.HomeBakDeviceList.719300-13') }}</div>
                    <div class="right-left-table-th right-left-table-th4">{{ $t('smartCity.HomeBakDeviceList.719300-35') }}</div>
                    <div class="right-left-table-th right-left-table-th3">{{ $t('smartCity.HomeBakDeviceList.719300-14') }}</div>
                    <div class="right-left-table-th right-left-table-th3">{{ $t('smartCity.HomeBakDeviceList.719300-15') }}</div>
                    <div class="right-left-table-th right-left-table-th4">{{ $t('smartCity.HomeBakDeviceList.719300-16') }}</div>
                </div>
                <div class="right-left-table-content">
                    <div class="right-left-table-tr" :class="index % 2 == 0 ? 'bg' : 'bg1'"
                        v-for="(item, index) in DeviceList" :key="index">
                        <div class="tr tr3">{{ item.UserDeviceName }}</div>
                        <div class="tr tr3">{{ item.DeviceCode }}</div>
                        <div class="tr tr3">{{ item.UserName }}</div>
                        <div class="tr tr3">{{ item.UpdateTime }}</div>
                        <div class="tr tr4">{{ item.Address }}</div>
                        <div class="tr tr3" :class="item.IsOnline == 1 ? 'greenText' : 'redText'">{{ item.IsOnline == true ?
                            $t('smartCity.HomeBakDeviceList.719300-17') : $t('smartCity.HomeBakDeviceList.719300-18') }}</div>
                        <div class="tr tr3">
                            <img class="Statusimg" v-if="item.SwitchStatus == 2" src="../../assets/homeback/close.png"
                                alt="">
                            <img class="Statusimg" v-else-if="item.SwitchStatus == 1" src="../../assets/homeback/open.png"
                                alt="">
                            <span v-else>--</span>
                        </div>
                        <div class="tr tr4 greenText">
                            <div class="map-right-group-btn" style="display: flex; align-items: center;">
                                <Poptip v-if="DeviceBtns.indexOf('slience') >= 0"
                                    style="align-items: center; margin-left: 5px;" confirm :title="$t('smartCity.HomeBakDeviceList.719300-19')"
                                    placement="top-start" offset='0' @on-ok="Device_YanGan_Silence(item)"
                                    @on-cancel="cancel">
                                    <div>
                                        <p>{{ $t('smartCity.HomeBakDeviceList.719300-20') }}</p>
                                    </div>
                                </Poptip>

                                <div v-if="DeviceBtns.indexOf('read') >= 0 && item.DeviceId == '6ee95d23-a802-4bd8-b823-19c0944ac5ab'"
                                    style="cursor: pointer;" :class="{ 'allowed': !callState }"
                                    @click="InitDeviceRead(item.DeviceCode, item.Id)">
                                    <p>{{ $t('smartCity.HomeBakDeviceList.719300-21') }}</p>
                                </div>

                                <Poptip
                                    v-if="DeviceBtns.indexOf('open') >= 0 && item.SwitchStatus != 2 && item.DeviceId == '6ee95d23-a802-4bd8-b823-19c0944ac5ab'"
                                    confirm :title="$t('smartCity.HomeBakDeviceList.719300-22')" :disabled="!saveState" placement="top-start" offset='0'
                                    @on-ok="VerifyPassword(item, 1)" @on-cancel="cancel">
                                    <div style="cursor: pointer;">
                                        <p>{{ $t('smartCity.HomeBakDeviceList.719300-23') }}</p>
                                    </div>
                                </Poptip>

                                <Poptip
                                    v-if="DeviceBtns.indexOf('close') >= 0 && item.SwitchStatus != 1 && item.DeviceId == '6ee95d23-a802-4bd8-b823-19c0944ac5ab'"
                                    confirm :title="$t('smartCity.HomeBakDeviceList.719300-24')" :disabled="!saveState" placement="top-start" offset='0'
                                    @on-ok="VerifyPassword(item, 1)" @on-cancel="cancel">
                                    <div style="cursor: pointer;">
                                        <p>{{ $t('smartCity.HomeBakDeviceList.719300-25') }}</p>
                                    </div>
                                </Poptip>

                                <Poptip v-if="DeviceBtns.indexOf('closeFa') >= 0" confirm :title="$t('smartCity.HomeBakDeviceList.719300-26')"
                                    :disabled="!saveState" placement="top-start" offset='0' @on-ok="VerifyPassword(item, 2)"
                                    @on-cancel="cancel">
                                    <div style="cursor: pointer;">
                                        <p>{{ $t('smartCity.HomeBakDeviceList.719300-27') }}</p>
                                    </div>
                                </Poptip>

                                <div style="cursor: pointer;"
                                    v-if="item.DeviceId == '88f5c429-49b6-4a9f-a908-b2ee9c8cb857' && item.DeviceItemId != '881a191a-e3da-4bea-867a-69988dbf1fef' && item.DeviceItemId != '147df81e-3f30-49b7-8894-f0b5794d917f' && item.DeviceItemId != 'c5307581-ff30-4115-87c0-52ac83bbd1cc'"
                                    @click="GetQtcgqTtItemList(item.DeviceCode)">
                                    <p>{{ $t('smartCity.HomeBakDeviceList.719300-28') }}</p>
                                </div>

                                <div style="cursor: pointer;" v-if="DeviceBtns.indexOf('edit') >= 0"
                                    @click="userListHide(true, 103)">
                                    <p>{{ $t('smartCity.HomeBakDeviceList.719300-29') }}</p>
                                </div>
                                <Poptip v-if="DeviceBtns.indexOf('del') >= 0" confirm :title="$t('smartCity.HomeBakDeviceList.719300-30')" placement="top-end"
                                    offset='-20' @on-ok="ok" @on-cancel="cancel">
                                    <div style="cursor: pointer;" class="map-right-group-btn-item set">
                                        <p>{{ $t('smartCity.HomeBakDeviceList.719300-31') }}</p>
                                    </div>
                                </Poptip>
                                <span style="cursor: pointer;" @click="ShowPopupDevice(item)">{{ $t('smartCity.HomeBakDeviceList.719300-32') }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="none" v-if="DeviceList.length == 0">{{ $t('smartCity.HomeBakDeviceList.719300-33') }}</div>
                </div>
            </div>
            <div class="right-left-table" v-if="PopupType == 'AlarmDevice'">
                <div class="table">
                    <div class="right-left-table-th right-left-table-th3">{{ $t('smartCity.HomeBakDeviceList.719300-36') }}</div>
                    <div class="right-left-table-th right-left-table-th3">{{ $t('smartCity.HomeBakDeviceList.719300-5') }}</div>
                    <div class="right-left-table-th right-left-table-th3">{{ $t('smartCity.HomeBakDeviceList.719300-12') }}</div>
                    <div class="right-left-table-th right-left-table-th3">{{ $t('smartCity.HomeBakDeviceList.719300-34') }}</div>
                    <div class="right-left-table-th right-left-table-th4">{{ $t('smartCity.HomeBakDeviceList.719300-37') }}</div>
                    <div class="right-left-table-th right-left-table-th4">{{ $t('smartCity.HomeBakDeviceList.719300-35') }}</div>
                    <div class="right-left-table-th right-left-table-th3">{{ $t('smartCity.HomeBakDeviceList.719300-14') }}</div>
                    <div class="right-left-table-th right-left-table-th5">{{ $t('smartCity.HomeBakDeviceList.719300-16') }}</div>
                </div>
                <div class="right-left-table-content">
                    <div class="right-left-table-tr" :class="index % 2 == 0 ? 'bg' : 'bg1'"
                        v-for="(item, index) in DeviceList" :key="index" @click="ShowPopupDevice(item)">
                        <div class="tr tr3">{{ index + 1 }}</div>
                        <div class="tr tr3">{{ item.UserDeviceName }}</div>
                        <div class="tr tr3">{{ item.DeviceCode }}</div>
                        <div class="tr tr3">{{ item.UserName }}</div>
                        <div class="tr tr4">{{ item.AbnormalTime }}</div>
                        <div class="tr tr4">{{ item.Address }}</div>
                        <div class="tr tr3" :class="item.IsOnline == 1 ? 'greenText' : 'redText'">{{ item.IsOnline == true ?
                            $t('smartCity.HomeBakDeviceList.719300-17') : $t('smartCity.HomeBakDeviceList.719300-18') }}</div>
                        <div class="tr tr5 greenText">
                            <span style="margin-right: 10px; cursor: pointer;"
                                @click.stop="OperateEvent(item.Id, 2)">{{ $t('smartCity.HomeBakDeviceList.719300-38') }}</span>
                            <span style="cursor: pointer; margin-right: 10px; "
                                @click.stop="OperateEvent(item.Id, 3)">{{ $t('smartCity.HomeBakDeviceList.719300-39') }}</span>
                            <span style="cursor: pointer;" @click="ShowPopupDevice(item)">{{ $t('smartCity.HomeBakDeviceList.719300-32') }}</span>

                        </div>
                    </div>
                    <div class="none" v-if="DeviceList.length == 0">{{ $t('smartCity.HomeBakDeviceList.719300-33') }}</div>
                </div>
            </div>
            <div class="right-left-table" v-if="PopupType == 'AlarmHandle'">
                <div class="table">
                    <div class="right-left-table-th right-left-table-th3">{{ $t('smartCity.HomeBakDeviceList.719300-36') }}</div>
                    <div class="right-left-table-th right-left-table-th3">{{ $t('smartCity.HomeBakDeviceList.719300-5') }}</div>
                    <div class="right-left-table-th right-left-table-th5">{{ $t('smartCity.HomeBakDeviceList.719300-12') }}</div>
                    <div class="right-left-table-th right-left-table-th3">{{ $t('smartCity.HomeBakDeviceList.719300-40') }}</div>
                    <div class="right-left-table-th right-left-table-th5">{{ $t('smartCity.HomeBakDeviceList.719300-41') }}</div>
                    <div class="right-left-table-th right-left-table-th3">{{ $t('smartCity.HomeBakDeviceList.719300-37') }}</div>
                    <div class="right-left-table-th right-left-table-th3">{{ $t('smartCity.HomeBakDeviceList.719300-42') }}</div>
                    <div class="right-left-table-th right-left-table-th3">{{ $t('smartCity.HomeBakDeviceList.719300-16') }}</div>
                </div>
                <div class="right-left-table-content">
                    <div class="right-left-table-tr" :class="index % 2 == 0 ? 'bg' : 'bg1'"
                        v-for="(item, index) in DeviceList" :key="index">
                        <div class="tr tr3">{{ index + 1 }}</div>
                        <div class="tr tr3">{{ item.UserDeviceName }}</div>
                        <div class="tr tr5">{{ item.DeviceCode }}</div>
                        <div class="tr tr3">{{ item.OwnerName }}</div>
                        <div class="tr tr5">{{ item.AddressDetail }}</div>
                        <div class="tr tr3">{{ item.AbnormalTime }}</div>
                        <div class="tr tr3 redText">{{ item.AbnormalName }}</div>
                        <div class="tr tr3 greenText">
                            <span style="margin-right: 10px; cursor: pointer;"
                                @click.stop="OperateEvent(item.Id, 2)">{{ $t('smartCity.HomeBakDeviceList.719300-38') }}</span>
                            <span style="cursor: pointer; margin-right: 10px; "
                                @click.stop="OperateEvent(item.Id, 3)">{{ $t('smartCity.HomeBakDeviceList.719300-39') }}</span>
                            <span style="cursor: pointer;" @click="ShowPopupDevice(item)">{{ $t('smartCity.HomeBakDeviceList.719300-32') }}</span>

                        </div>
                    </div>
                    <div class="none" v-if="DeviceList.length == 0">{{ $t('smartCity.HomeBakDeviceList.719300-33') }}</div>
                </div>
            </div>
            <div class="right-left-table" v-if="PopupType == 'ZuiJinAlarmDevice'">
                <div class="table">
                    <div class="right-left-table-th right-left-table-th3">{{ $t('smartCity.HomeBakDeviceList.719300-36') }}</div>
                    <div class="right-left-table-th right-left-table-th3">{{ $t('smartCity.HomeBakDeviceList.719300-5') }}</div>
                    <div class="right-left-table-th right-left-table-th5">{{ $t('smartCity.HomeBakDeviceList.719300-12') }}</div>
                    <div class="right-left-table-th right-left-table-th3">{{ $t('smartCity.HomeBakDeviceList.719300-40') }}</div>
                    <div class="right-left-table-th right-left-table-th5">{{ $t('smartCity.HomeBakDeviceList.719300-41') }}</div>
                    <div class="right-left-table-th right-left-table-th3">{{ $t('smartCity.HomeBakDeviceList.719300-37') }}</div>
                    <div class="right-left-table-th right-left-table-th3">{{ $t('smartCity.HomeBakDeviceList.719300-42') }}</div>
                    <div class="right-left-table-th right-left-table-th4">{{ $t('smartCity.HomeBakDeviceList.719300-16') }}</div>
                </div>
                <div class="right-left-table-content">
                    <div class="right-left-table-tr" :class="index % 2 == 0 ? 'bg' : 'bg1'"
                        v-for="(item, index) in DeviceList" :key="index">
                        <div class="tr tr3">{{ index + 1 }}</div>
                        <div class="tr tr3">{{ item.UserDeviceName }}</div>
                        <div class="tr tr5">{{ item.DeviceCode }}</div>
                        <div class="tr tr3">{{ item.OwnerName }}</div>
                        <div class="tr tr5">{{ item.AddressDetail }}</div>
                        <div class="tr tr3">{{ item.AbnormalTime }}</div>
                        <div class="tr tr3 redText">{{ item.AbnormalName }}</div>
                        <div class="tr tr4 greenText">
                            <span style="margin-right: 10px; cursor: pointer;"
                                @click.stop="OperateEvent(item.Id, 2)">{{ $t('smartCity.HomeBakDeviceList.719300-38') }}</span>
                            <span style="cursor: pointer; margin-right: 10px;"
                                @click.stop="OperateEvent(item.Id, 3)">{{ $t('smartCity.HomeBakDeviceList.719300-39') }}</span>
                            <span style="cursor: pointer;" @click="ShowPopupDevice(item)">{{ $t('smartCity.HomeBakDeviceList.719300-32') }}</span>

                        </div>
                    </div>
                    <div class="none" v-if="DeviceList.length == 0">{{ $t('smartCity.HomeBakDeviceList.719300-33') }}</div>
                </div>
            </div>
            <div class="user-top-list-page">
                <Page :total="pageListTotalCount" @on-change="ChangePageIndex" @on-page-size-change="ChangePageSize"
                    size="small" show-elevator show-sizer show-total placement="top" />
            </div>
        </div>
    </div>
</template>
<script>
import Cookies from "js-cookie";
import api from "../../api/request.js";
export default {
    props: {
        Popuplist: {
            type: Array,
            default() {
                return []
            }
        },
        PopupType: {
            Type: String,
            default() {
                return ''
            }
        },
        PopupStatus: {
            Type: String,
            default() {
                return ''
            }
        }
    },
    data() {
        return {
            DeviceList: [], //设备列表
            DeviceBtns: ['read', 'open', 'close'],//操作按钮列表
            InputParams: undefined,
            InputTypeParams: '',
            DeviceTypeList: [
                {
                    name: this.$t('smartCity.HomeBakDeviceList.719300-43'),
                    value:''
                }, {
                    name: this.$t('smartCity.HomeBakDeviceList.719300-44'),
                    value: 'wd'
                }, {
                    name: this.$t('smartCity.HomeBakDeviceList.719300-45'),
                    value: 'qg'
                }, {
                    name: this.$t('smartCity.HomeBakDeviceList.719300-46'),
                    value: 'yg'
                }, {
                    name: this.$t('smartCity.HomeBakDeviceList.719300-47'),
                    value: 'rqdcf'
                }],
            timeValue: '2023-7-12',
            StarDay: '2023-7-12',
            OperateList: [
                {
                    name: this.$t('smartCity.HomeBakDeviceList.719300-38'),
                    value: '2',
                },
                {
                    name: this.$t('smartCity.HomeBakDeviceList.719300-39'),
                    value: '3'
                }
            ],
            saveState: true,
            callState: true,
            pageListTotalCount: 1,
            pageIndex: 1,
            pageSize: 10,
            DeviceDetails: undefined,
            SelectData: 1
        };
    },
    watch: {
        Popuplist: {
            handler(newVal, oldVal) {
                // this.DeviceList = newVal
                // console.log('this.DeviceList', this.DeviceList)
                this.search()

            },
            immediate: true
        }

    },
    mounted() {
        let _this = this
        _this.timeValue = _this.getDate(0)
        _this.StarDay = _this.getDate(7)
    },
    methods: {
        ChangePageIndex(val) {
            console.log(this.$t('smartCity.HomeBakDeviceList.719300-48'), val)
            let _this = this
            _this.pageIndex = val
            _this.search()
        },
        ChangePageSize(val) {
            console.log(this.$t('smartCity.HomeBakDeviceList.719300-49'), val)
            let _this = this
            _this.pageSize = val
            _this.ChangePageIndex(1)

        },
        // 烟感设备消音（yhj）
        Device_YanGan_Silence(item) {
            let _this = this;
            api({
                //这里是你自己的请求方式、url和data参数
                method: 'get',
                url: `api/YhjDevice/Device_YanGan_Silence?deviceCode=${item.DeviceCode}`,
                data: {},
                //假设后台需要的是表单数据这里你就可以更改
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                    "Authorization": Cookies.get('Token')
                }
            }, 'yhj').then(function (res) {
                if (res.Success) {

                    _this.$Message['success']({
                        background: true,
                        content: res.Message
                    });

                } else {
                    _this.$Message['error']({
                        background: true,
                        content: res.Message
                    });
                }
            }).catch(function (err) {
                _this.$Message['error']({
                    background: true,
                    content: this.$t('smartCity.HomeBakDeviceList.719300-50')
                });
            });
        },
        // 验证密码
        VerifyPassword(item, type) {
            console.log(type)
            let _this = this;
            if (!_this.saveState) {
                return;
            }
            _this.DeviceDetails = item
            // 存在操作密码
            if (this.passWordIndex) {
                this.$Modal.confirm({
                    title: this.$t('smartCity.HomeBakDeviceList.719300-51'),
                    render: (h) => {
                        return h('Input', {
                            props: {
                                value: this.value,
                                autofocus: true,
                                placeholder: this.$t('smartCity.HomeBakDeviceList.719300-52')
                            },
                            on: {
                                input: (val) => {
                                    this.operatPassword = val;
                                }
                            }
                        })
                    },
                    onOk: () => {
                        // 检查密码是否一致
                        this.getVerifyPassword(type)
                    }
                })
                return
            }
            if (type == 1) {
                // 分合闸（yhj）
                _this.SaveDeviceKGStatus();
            } else if (type == 2) {
                // 关阀
                _this.CloseRanQiDianCiFa();
            }
        },
        // 检查密码是否一致
        getVerifyPassword(type) {
            api({
                //这里是你自己的请求方式、url和data参数
                method: 'post',
                url: 'api/User/VerifyPassword',
                data: {
                    password: this.operatPassword
                },
                //假设后台需要的是表单数据这里你就可以更改
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                    "Authorization": Cookies.get('Token')
                }
            }).then((res) => {
                if (res.Success) {
                    if (type == 1) {
                        // 分合闸（yhj）
                        this.SaveDeviceKGStatus();
                    } else if (type == 2) {
                        // 关阀
                        this.CloseRanQiDianCiFa();
                    }
                } else {
                    this.$Message['error']({
                        background: true,
                        content: res.Message
                    });
                }
            });
        },

        // 分合闸（yhj）
        SaveDeviceKGStatus() {
            let _this = this;

            if (_this.operatMsg) {
                _this.$Message['error']({
                    background: true,
                    content: this.$t('smartCity.HomeBakDeviceList.719300-53')
                });
                return;
            }

            let data = {
                Id: _this.DeviceDetails.Id,
                SwitchStatus: _this.DeviceDetails.SwitchStatus == 2 ? 1 : 2,
            }
            // const msg = this.$Message.loading({
            //   content: '操作中...',
            //   duration: 0
            // });
            _this.spinMsg = true;
            _this.spinTitle = this.$t('smartCity.HomeBakDeviceList.719300-54');

            _this.saveState = false;
            api({
                //这里是你自己的请求方式、url和data参数
                method: 'post',
                url: 'api/YhjDevice/SaveDeviceKGStatus',
                data: data,
                //假设后台需要的是表单数据这里你就可以更改
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                    "Authorization": Cookies.get('Token')
                }
            }, 'yhj').then(function (res) {
                // setTimeout(msg, 10);
                _this.spinMsg = false;
                _this.spinTitle = '';

                _this.saveState = true;
                if (res.Success) {
                    // _this.GetOneUserDevice(_this.DeviceDetails.Id);
                    _this.DeviceDetails.SwitchStatus = _this.DeviceDetails.SwitchStatus == 2 ? 1 : 2;
                    _this.$Notice.success({
                        title: this.$t('smartCity.HomeBakDeviceList.719300-55'),
                        desc: res.Message
                    });

                    _this.operatMsg = true;
                    setTimeout(() => {
                        _this.operatMsg = false;
                    }, 7000);

                } else {
                    _this.$Notice.error({
                        title: this.$t('smartCity.HomeBakDeviceList.719300-55'),
                        desc: res.Message
                    });
                }
            }).catch(function (err) {
                // setTimeout(msg, 10);
                _this.$Notice.error({
                    title: this.$t('smartCity.HomeBakDeviceList.719300-50'),
                    desc: res.Message
                });
            });
        },

        // 关闭燃气电磁阀/切断阀
        CloseRanQiDianCiFa() {
            let _this = this;
            if (_this.operatMsg) {
                _this.$Message['error']({
                    background: true,
                    content: this.$t('smartCity.HomeBakDeviceList.719300-53')
                });
                return;
            }
            _this.spinMsg = true;
            _this.spinTitle = this.$t('smartCity.HomeBakDeviceList.719300-54');
            _this.saveState = false;
            api({
                //这里是你自己的请求方式、url和data参数
                method: 'get',
                url: 'api/YhjDevice/CloseRanQiDianCiFa?deviceCode=' + _this.DeviceDetails.DeviceCode,
                data: {},
                //假设后台需要的是表单数据这里你就可以更改
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                    "Authorization": Cookies.get('Token')
                }
            }, 'yhj').then(function (res) {
                _this.spinMsg = false;
                _this.spinTitle = '';
                _this.saveState = true;
                if (res.Success) {
                    _this.$Notice.success({
                        title: this.$t('smartCity.HomeBakDeviceList.719300-55'),
                        desc: res.Message
                    });
                    _this.operatMsg = true;
                    setTimeout(() => {
                        _this.operatMsg = false;
                    }, 7000);
                } else {
                    _this.$Notice.error({
                        title: this.$t('smartCity.HomeBakDeviceList.719300-55'),
                        desc: res.Message
                    });
                }
            }).catch(function (err) {
                _this.$Notice.error({
                    title: this.$t('smartCity.HomeBakDeviceList.719300-50'),
                    desc: res.Message
                });
            });
        },

        // 获取传感器探头
        GetQtcgqTtItemList(DeviceCode) {
            let _this = this;
            _this.qtcgqTtItemMsg = false;
            api({
                //这里是你自己的请求方式、url和data参数
                method: 'get',
                url: `api/YhjDevice/GetQtcgqTtItemList?deviceCode=${DeviceCode}`,
                data: {},
                //假设后台需要的是表单数据这里你就可以更改
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                    "Authorization": Cookies.get('Token')
                }
            }, 'yhj').then(function (res) {
                _this.qtcgqTtItemMsg = true;
                if (res.Success) {

                    _this.qtcgqTtItemLists = res.Data;


                } else {
                    _this.$Message['error']({
                        background: true,
                        content: res.Message
                    });
                }
            }).catch(function (err) {
                _this.qtcgqTtItemMsg = true;
            });
        },

        // 删除设备
        ok() {
            let _this = this;
            let data = {
                DeviceCodeList: [_this.DeviceDetails.DeviceCode]
            }
            api({
                //这里是你自己的请求方式、url和data参数
                method: 'post',
                url: 'api/YhjDevice/DeleteUserDevice',
                data: data,
                //假设后台需要的是表单数据这里你就可以更改
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                    "Authorization": Cookies.get('Token')
                }
            }, 'yhj').then(function (res) {
                if (res.Success) {
                    _this.$Message['success']({
                        background: true,
                        content: res.Message
                    });
                    _this.GetUserDevicesPage();
                    _this.Back(1);
                } else {
                    _this.$Message['error']({
                        background: true,
                        content: res.Message
                    });
                }
            }).catch(function (err) {
                _this.$Message['error']({
                    background: true,
                    content: this.$t('smartCity.HomeBakDeviceList.719300-50')
                });
            });
        },


        // 召测（yhj）
        InitDeviceRead(DeviceCode, Id) {
            let _this = this;

            if (_this.operatMsg) {
                _this.$Message['error']({
                    background: true,
                    content: this.$t('smartCity.HomeBakDeviceList.719300-53')
                });
                return;
            }

            if (!_this.callState) {
                return;
            }

            // const msg = this.$Message.loading({
            //   content: '召测中...',
            //   duration: 0
            // });

            _this.spinMsg = true;
            _this.spinTitle = this.$t('smartCity.HomeBakDeviceList.719300-56');

            _this.callState = false;

            api({
                //这里是你自己的请求方式、url和data参数
                method: 'get',
                url: 'api/YhjDevice/InitDeviceRead?deviceCode=' + DeviceCode,
                data: {},
                //假设后台需要的是表单数据这里你就可以更改
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                    "Authorization": Cookies.get('Token')
                }
            }, 'yhj').then(function (res) {
                _this.callState = true;
                // setTimeout(msg, 10);

                _this.spinMsg = false;
                _this.spinTitle = '';

                if (res.Success) {
                    if (res.Code === 0) {
                        _this.$Notice.success({
                            title: this.$t('smartCity.HomeBakDeviceList.719300-55'),
                            desc: res.Message
                        });
                    } else {
                        _this.$Notice.error({
                            title: this.$t('smartCity.HomeBakDeviceList.719300-55'),
                            desc: res.Message
                        });
                    }

                    _this.operatMsg = true;
                    setTimeout(() => {
                        _this.operatMsg = false;
                    }, 7000);

                } else {
                    _this.callState = true;
                    // setTimeout(msg, 10);
                    _this.$Message['error']({
                        background: true,
                        content: res.Message
                    });
                }
            }).catch(function (err) {
                _this.$Message['error']({
                    background: true,
                    content: this.$t('smartCity.HomeBakDeviceList.719300-50')
                });
            });
        },
        cancel() { },
        getDate(n) {
            let oneDay = 24 * 60 * 60 * 1000
            let date = new Date(Date.now() - n * oneDay)
            let Y = date.getFullYear()
            let M = date.getMonth() + 1
            let D = date.getDate()
            return Y + '-' + M + '-' + D;
        },
        closePopup() {
            this.$emit("childEvent", false)
        },
        ShowPopupDevice(item) {
            console.log(this.$t('smartCity.HomeBakDeviceList.719300-57'), item)
            let _this = this
            if (item.DeviceId == '8d96d8de-698b-4961-b5ba-c374cfb32010') {
                this.ShowCamera(item)
            } else {
                if (_this.PopupType == 'ZuiJinAlarmDevice') {
                    let _this = this,
                        AdminData = JSON.parse(Cookies.get('AdminData'));
                    api({
                        method: 'get',
                        url: `api/CommElecDevice/GetUserDevicesPageV2`,
                        params: {
                            groupCode: AdminData.GroupCode,
                            companyCode: AdminData.CompanyCode,
                            departmentCode: AdminData.DepartmentCode,
                            isAdmin: AdminData.IsAdmin,
                            pageIndex: _this.pageIndex,
                            pageSize: _this.pageSize,
                            deviceCode: item.DeviceCode
                        },
                        headers: {
                            "Authorization": Cookies.get('Token')
                        }
                    }, 'yhj').then(function (res) {
                        if (res.Success) {
                            _this.$emit("childEvent1", res.Data[0])
                        } else {
                            _this.$Message['error']({
                                background: true,
                                content: res.Message
                            });
                        }
                    }).catch((err) => {
                        _this.$Message['error']({
                            background: true,
                            content: err.data.Message
                        });
                    })
                } else {
                    //关闭设备列表弹窗打开设备详情弹窗
                    _this.$emit("childEvent1", item)
                }
            }
        },
        //打开摄像头页面
        ShowCamera(item) {
            if (!Cookies.get('AdminData')) {
                return
            }
            let _this = this,
                AdminData = JSON.parse(Cookies.get('AdminData'))
            let deviceSerial = item.DeviceCode,
                validateCode = item.Mac
            api({
                method: 'get',
                url: `api/YhjDevice/GetYsDeviceMonitor?deviceSerial=${deviceSerial}&validateCode=${validateCode}`,
                data: {},
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                    "Authorization": Cookies.get('Token')
                }
            }, 'yhj').then(res => {
                console.log(res.Data.LiveSrc, 12333);
                _this.liveSrc = res.Data.LiveSrc
                window.open(_this.liveSrc, '_blank')
            })
        },
        search() {
            let _this = this,
                PopupType = _this.PopupType
            switch (PopupType) {
                case 'AllDevice':
                    _this.GetAllDeviceList()
                    break;
                case 'ZuiJinAlarmDevice':
                case 'AlarmDevice':
                case 'AlarmHandle':
                    _this.GetAlarmDeviceList()
                    break;
                case 'online':
                    _this.GetIsOnlineDeviceList()
                    break;


            }

        },
        //获取所有设备的设备列表
        GetAllDeviceList() {
            if (!Cookies.get('AdminData')) {
                return;
            }
            let _this = this,
                AdminData = JSON.parse(Cookies.get('AdminData'));
            api({
                method: 'get',
                url: `api/CommElecDevice/GetUserDevicesPageV2`,
                params: {
                    groupCode: AdminData.GroupCode,
                    companyCode: AdminData.CompanyCode,
                    departmentCode: AdminData.DepartmentCode,
                    isAdmin: AdminData.IsAdmin,
                    pageIndex: _this.pageIndex,
                    pageSize: _this.pageSize,
                    DeviceName: _this.InputParams,
                    deviceType: _this.InputTypeParams
                },
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                    "Authorization": Cookies.get('Token')
                }
            }, 'yhj').then(function (res) {
                if (res.Success) {
                    _this.DeviceList = res.Data;
                    _this.pageListTotalCount = res.TotalCount
                } else {
                    _this.$Message['error']({
                        background: true,
                        content: res.Message
                    });
                }
            }).catch((err) => {
                _this.$Message['error']({
                    background: true,
                    content: err.data.Message
                });
            })
        },
        //获取报警的设备列表,pstate：0为全部数据,1为未处理的数据,2为已处理的数据
        GetAlarmDeviceList() {
            let _this = this,
                AdminData = JSON.parse(Cookies.get('AdminData')),
                handlerUrl = `api/YhjStatic/GetDeviceAbnormalPageListWith3Code`,
                QiTianUrl = `api/CommElecDevice/GetCurrRoomAbDevices`,
                AllDeviceUrl = `api/YhjStatic/GetDeviceAbnormalPageListWith3Code`,
                url = '';
            let params = {
                groupCode: AdminData.GroupCode,
                companyCode: AdminData.CompanyCode,
                departmentCode: AdminData.DepartmentCode,
                pageIndex: _this.pageIndex,
                pageSize: _this.pageSize,
                pstate: _this.PopupStatus,
                isAdmin: AdminData.IsAdmin,
                DeviceCode: _this.InputParams,
                deviceType: _this.InputTypeParams
            }
            if (_this.PopupType == 'AlarmHandle') {
                url = handlerUrl
                params.startDt = _this.timeValue;
                params.endDt = _this.timeValue
            } else if (_this.PopupType == 'ZuiJinAlarmDevice') {
                url = AllDeviceUrl
            } else {
                url = QiTianUrl
            }
            api({
                method: 'get',
                url: url,
                params: params,
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                    "Authorization": Cookies.get('Token') ? Cookies.get('Token') : ''
                }
            }, 'yhj').then(function (res) {
                if (res.Success) {
                    _this.DeviceList = res.Data
                } else {
                    _this.$Message['error']({
                        background: true,
                        content: res.Message
                    });
                }
            }).catch((err) => {
                _this.$Message['error']({
                    background: true,
                    content: err.data.Message
                });
            })
        },
        //获取在线/离线的设备列表
        GetIsOnlineDeviceList() {
            let _this = this,
                AdminData = JSON.parse(Cookies.get('AdminData'));
            api({
                method: 'get',
                url: `api/CommElecDevice/GetUserDevicesPageV2`,
                params: {
                    groupCode: AdminData.GroupCode,
                    companyCode: AdminData.CompanyCode,
                    departmentCode: AdminData.DepartmentCode,
                    isAdmin: AdminData.IsAdmin,
                    pageIndex: _this.pageIndex,
                    pageSize: _this.pageSize,
                    onlineState: _this.PopupStatus,
                    deviceName: _this.InputParams,
                    deviceType: _this.InputTypeParams
                },
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                    "Authorization": Cookies.get('Token')
                }
            }, 'yhj').then(function (res) {
                if (res.Success) {
                    _this.DeviceList = res.Data;
                } else {
                    _this.$Message['error']({
                        background: true,
                        content: res.Message
                    });
                }
            }).catch((err) => {
                _this.$Message['error']({
                    background: true,
                    content: err.data.Message
                });
            })
        },
        // 及时告警信息处理 type 2、处理 3、误报（yhj）
        OperateEvent(Id, type, state) {
            let _this = this,
                AdminData = JSON.parse(Cookies.get('AdminData'));
            _this.$Modal.confirm({
                title: this.$t('smartCity.HomeBakDeviceList.719300-55'),
                content: `<p>是否对设备进行${type == 2 ? this.$t('smartCity.HomeBakDeviceList.719300-38') : this.$t('smartCity.HomeBakDeviceList.719300-39')}操作</p>`,
                onOk: () => {
                    api({
                        method: 'get',
                        url: `api/YhjDevice/ProcessUserDeviceAbnormal?groupCode=${AdminData.GroupCode}&companyCode=${AdminData.CompanyCode}&departmentCode=${AdminData.DepartmentCode}&userDeviceAbnormal_Id=${Id}&pstate=${type}`,
                        data: {},
                        headers: {
                            "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                            "Authorization": Cookies.get('Token')
                        }
                    }, 'yhj').then(function (res) {
                        if (res.Success) {
                            _this.$Message['success']({
                                background: true,
                                content: res.Message
                            });
                            _this.GetAlarmDeviceList()
                        } else {
                            _this.$Message['error']({
                                background: true,
                                content: res.Message
                            });
                        }
                    }).catch(function (err) {
                        // _this.$Message['error']({
                        //   background: true,
                        //   content: this.$t('smartCity.HomeBakDeviceList.719300-50')
                        // });
                    });
                },
                onCancel: () => {

                }
            });

        },
    }
}
</script>


<style scoped="scoped" lang="scss">
@import "./big_screen_default.scss";
@import "./big_screen.scss";
@import "./home_back1.scss";
@import url("./index.css");

.map-right-group-btn {
    >div {
        margin-right: 10px;
    }
}

.ifram_bgclo {
    background-color: #fff;
    width: 100vw;
    height: 100vh;
}

.redText {
    color: #f03613;
}

.greenText {
    color: #18e8ca;
}

.blueText {
    color: #0078d4;
}

.tr {
    .Statusimg {
        width: 15px;
        height: 15px;
    }
}

.dropDown1Button {
    display: inline-block;
    height: 1.5vw;
    line-height: 1.5vw;
    margin: -0.05vw 0.2vw 0.1vw 0;
    padding: 0 0.4vw;
    border-radius: 0.15vw;
    background-color: #18e8ca;
    font-size: 0.6vw;
    vertical-align: middle;
    overflow: hidden;
    cursor: pointer;
    color: #494949;
}

.searchButton {
    padding: 4px 10px;
    background-color: #18e8ca;
    color: #494949;
    border-radius: 4px;
    display: flex;
    align-items: center;
    cursor: pointer;
}



.user-top-list-page {
    margin-top: 4vh;
}

.none {
    color: #fff;
    text-align: center;
    margin-top: 5vh;
}
.ivu-select-arrow{
    color:#fff;
}
.ivu-select-selection {
    color: #fff;
    background-color: rgba(255, 255, 255, 0.2);
}
.ivu-select-item-selected{
    color:#18e8ca;
}
.ivu-select-visible .ivu-select-selection {
    border-color: #18e8ca;
}
.ivu-select-selection-focused, .ivu-select-selection:hover {
    border-color: #18e8ca;
}
.ivu-select-single .ivu-select-selection .ivu-select-placeholder {
    color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/components/smartCity/HomeBakDeviceList.vue